import React, { useEffect, useState } from "react";
import { apiGetProcesses } from "../../../api/ApiProcess";
import { Link } from "react-router-dom";
import { getObjects } from "../../../utils/objects";
import { isNode } from "react-flow-renderer";

const ComponentBreadcrumb = (props) => {
  // la props isForAdmin peut etre à  :
  // true : générera un fil d'ariane pour la partie admin de la carto =>  /admin/easygouv/processes/id_du_process_a_consulter/view
  // false ou pas renseigne : générera un fil d'ariane poiur la partie publique des cartos =>  /processes/id_du_process_a_consulter

  const { isForAdmin, idProcess, ReduxInstanceId } = props;
  const [processes, setProcesses] = useState([]);
  const [arborescenceComplete, setArborescenceComplete] = useState([]);

  const creationArborescence = () => {
    var arborescence = [];
    processes
      .filter((item) => item.famille === "MacroProcess")
      .forEach((process) => {
        let node = {};
        node.id = process._id;
        node.nom = process.nom;
        if (process.view.length) {
          node.childrens = [];
        }
        arborescence.push(node);
        addRecursiveNode(node, process);
      });
    setArborescenceComplete(arborescence);
  };

  const addRecursiveNode = (noeudParent, process) => {
    var hasview = false;
    var enfantsIdentite = [];
    if (process.view) {
      hasview = true;
      const enfantsPrincipaux = [];
      for (const noeud of process.view) {
        if (isNode(noeud) && noeud.data.template === 0) {
          enfantsPrincipaux.push(noeud.data.process);
        }
      }
      enfantsPrincipaux.forEach((enfant) =>
        enfantsIdentite.push(processes.find((element) => element._id === enfant))
      );
    }
    if (hasview) {
      enfantsIdentite.forEach((enfant) => {
        let node = {};
        node.id = enfant._id;
        node.nom = enfant.nom;
        if (enfant.view.length) {
          node.childrens = [];
        }
        noeudParent.childrens.push(node);
        addRecursiveNode(node, enfant);
      });
    }
  };

  const RecursiveComponentBreadcrumb = ({ objet, niveau }) => {
    const found = getObjects(objet, "", idProcess);
    var lienBreadcrumb = `/processes/${objet.id}`;

    if (!found.length) {
      return false;
    }

    if (isForAdmin) {
      lienBreadcrumb = `/admin/easygouv/processes/${objet.id}/view`;
    }

    return (
      <>
        {objet.id !== idProcess && (
          <li className="breadcrumb-item">
            <Link to={lienBreadcrumb}>{objet.nom}</Link>
          </li>
        )}

        {objet.id === idProcess && <li className="breadcrumb-item active">{objet.nom}</li>}

        {objet.childrens &&
          objet.childrens.map((enfant) => (
            <RecursiveComponentBreadcrumb
              key={enfant.id}
              objet={enfant}
              detailView={enfant.childrens}
              niveau={niveau + 1}
            />
          ))}
      </>
    );
  };

  const recupProcesses = async () => {
    const res = await apiGetProcesses(ReduxInstanceId);
    setProcesses(res.data);
  };

  useEffect(() => {
    if (processes.length) {
      creationArborescence();
    }
  }, [processes]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    recupProcesses();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {arborescenceComplete.map((macroProcess) => (
          <RecursiveComponentBreadcrumb key={macroProcess.id} objet={macroProcess} niveau={0} />
        ))}
      </ol>
    </nav>
  );
};

export default ComponentBreadcrumb;
